import { CSSProperties } from 'react';

const toCssSpacing = (value?: string): string | undefined => {
  const trimmed = value?.trim();
  return trimmed || undefined;
};

export const buildResponsiveSpacingVars = (
  componentPrefix: string,
  type: 'margin' | 'padding',
  desktop?: string,
  mobile?: string
): CSSProperties => {
  const vars: Record<string, string> = {};
  const desktopValue = toCssSpacing(desktop);
  const mobileValue = toCssSpacing(mobile);

  if (desktopValue) {
    vars[`--${componentPrefix}-${type}`] = desktopValue;
  }
  if (mobileValue) {
    vars[`--${componentPrefix}-${type}-mobile`] = mobileValue;
  }

  return vars as CSSProperties;
};

export const mergeResponsiveSpacingVars = (
  componentPrefix: string,
  spacing?: {
    margin?: string;
    marginMobile?: string;
    padding?: string;
    paddingMobile?: string;
  }
): CSSProperties => ({
  ...buildResponsiveSpacingVars(componentPrefix, 'margin', spacing?.margin, spacing?.marginMobile),
  ...buildResponsiveSpacingVars(
    componentPrefix,
    'padding',
    spacing?.padding,
    spacing?.paddingMobile
  ),
});
